/* eslint-disable import/no-named-as-default */
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import cx from 'classnames';
import {
  StandardComponentType,
  StatusComponentType,
  StatusTimelineComponentType,
  TimelineComponentType,
  TextComponentType,
  ImageComponentType,
} from '../../../constants/componentTypes';
import StandardFormatData from '../StandardFormatData';
import TrackingComponent from '../TrackingComponent';
import styles from './RowItem.scss';

const isTrackingComponent = (rowItem) => rowItem.componentType === StatusComponentType
  || rowItem.componentType === StatusTimelineComponentType
  || rowItem.componentType === TimelineComponentType;

const isFilledTrackingComponent = (rowItem) => isTrackingComponent(rowItem);

function ComposeRowItemElements(props) {
  const {
    rowItem,
    isTrackingPageFontExisted,
    uploadedTrackingPageFont,
    trackingPageFont,
  } = props;

  switch (rowItem.componentType) {
    case TextComponentType:
    case ImageComponentType:
    case StandardComponentType:
      return (
        <StandardFormatData
          rowItem={rowItem}
          isTrackingPageFontExisted={isTrackingPageFontExisted}
          trackingPageFont={trackingPageFont}
          uploadedTrackingPageFont={uploadedTrackingPageFont}
        />
      );
    case StatusComponentType:
    case StatusTimelineComponentType:
    case TimelineComponentType:
      return (
        <TrackingComponent
          rowItem={rowItem}
          isTrackingPageFontExisted={isTrackingPageFontExisted}
          uploadedTrackingPageFont={uploadedTrackingPageFont}
        />
      );
    default:
      return '';
  }
}

function RowItem(props) {
  const { rowItem } = props;
  return (
    <div className={
      cx(
        styles.rowItem,
        {
          [styles.trackingRowItem]: rowItem && isFilledTrackingComponent(rowItem),
        },
      )
    }
    >
      {
        rowItem.font && (
          <Helmet link={[{ href: rowItem.font.url, rel: 'stylesheet' }]} />
        )
      }
      {
        ComposeRowItemElements(props)
      }
    </div>
  );
}

const mapStateToProps = ({
  trackingPage: {
    shipment, trackingPageData: { font: trackingPageFont },
  },
}) => ({
  shipment,
  trackingPageFont,
});

export default connect(mapStateToProps)(RowItem);
